export const CompaniesActions = {
  SET_ATTRIBUTE: "COMPANIES_SET_ATTRIBUTE",
  RESET_STATE: "COMPANIES_RESET_STATE"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setCompaniesAttribute = (key, value) => {
  return {
    type: CompaniesActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const companiesResetState = () => {
  return {
    type: CompaniesActions.RESET_STATE
  }
}
